import { GenerateMediaDescriptionRequest, GenerateMediaDescriptionResponse, SaveMediaDescriptionRequest } from '../types/types';
import { HttpResponse, makeRequest } from './index';

const endpoint = 'MediaDescription';

export const generateMediaDescription = async (fileId: string): Promise<HttpResponse<GenerateMediaDescriptionResponse>> => {
	const result = await makeRequest<GenerateMediaDescriptionRequest, GenerateMediaDescriptionResponse>(`${endpoint}/generate`, { fileId }, 'post');
	return result;
};

export const saveMediaDescription = async (request: SaveMediaDescriptionRequest): Promise<HttpResponse<null>> => {
	const result = await makeRequest<SaveMediaDescriptionRequest, null>(`${endpoint}`, request, 'put');
	return result;
};
